import { EJLog } from '../../../../constants/cimsPage/instances/ej'
import { CreateViewEditSoftRemoveRestore, Revert } from '../../common'

const page = EJLog
const object = 'Engineering Judgement'
const plural = 'engineering judgements'

const log = CreateViewEditSoftRemoveRestore({
  page,
  object,
  plural,
  create: '38254DF7-D0B2-4FCE-951D-09192C096520',
  view: '2C78C858-8C31-42FB-8D73-6339DA5C04C4',
  edit: 'B2BA55D5-9670-4040-9A03-2FD78E5424ED',
  removeRestore: '6C88B859-CCE4-4AB7-9687-9A2493780E31',
})

export const CreateEngineeringJudgement = log.Create
export const ViewEngineeringJudgement = log.View
export const EditEngineeringJudgement = log.Edit
export const RemoveRestoreEngineeringJudgement = log.RemoveRestore

export const RevertEngineeringJudgement = Revert({
  id: 'F00B5272-EAD8-4800-931B-2DDDBD9E0457',
  page,
  object,
  plural,
})

export type EJLogPermission =
  | typeof CreateEngineeringJudgement
  | typeof ViewEngineeringJudgement
  | typeof EditEngineeringJudgement
  | typeof RemoveRestoreEngineeringJudgement
  | typeof RevertEngineeringJudgement
